import Joi from 'joi';
import { ALLOWED_MIME_TYPES, FILE_SIZE_LIMIT_IN_BYTES } from './config';

export const fileSchema = Joi.object({
  type: Joi.string()
    .valid(...ALLOWED_MIME_TYPES)
    .required()
    .messages({
      'any.only': 'File type is not supported',
    }),
  size: Joi.number().max(FILE_SIZE_LIMIT_IN_BYTES).required().messages({
    'number.max': 'File size is too large',
  }),
});
